module.exports = __webpack_public_path__ + "static/img/banner1.1e4fc53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/banner1.jpg
// module id = Dmmf
// module chunks = 0